import { Alert } from "antd";
import { ErrorList } from "./ErrorList";

type UploadValidationErrorsProps = {
  errors: string[];
};

export const UploadValidationErrors = ({
  errors,
}: UploadValidationErrorsProps) => {
  return (
    <Alert
      type="error"
      className="align-start mb-6"
      showIcon
      message={<ErrorList errors={errors} />}
    />
  );
};
